import { useState } from 'react'
import { classNames } from '@/util/tailwindHelpers'
import { InfoBlockDefinition } from './InfoBlock'
import Button from '../Button'
import { ScarcityMeter } from '../Meter/ScarcityMeter'

export const scarcityBlock = (value: number): InfoBlockDefinition => {
  return {
    label: 'Scarcity',
    additionalInfo: value
      ? 'Scarcity shows how many remain in existence that are collected.'
      : 'This item is no longer in circulation.',
    value: {
      type: 'meter',
      value: value
    }
  }
}

export const ScarcityInfoBlock = ({ value, style }) => {
  const [showRawValue, setShowRawValue] = useState(false)
  const isSoloStyle = style == 'solo'
  return (
    <div className="flex-1 flex gap-[12px] items-center">
      <div
        className={classNames('flex-1 flex relative', {
          'justify-end': isSoloStyle
        })}
      >
        <div
          className={classNames('body-md absolute top-1/2 -translate-y-1/2', {
            invisible: !showRawValue
          })}
        >
          {value.value}%&nbsp;Available
        </div>
        <ScarcityMeter
          className={classNames('flex-1 py-half', {
            invisible: showRawValue,
            'max-w-[132px]': isSoloStyle
          })}
          percentage={value.value}
        />
      </div>

      <div
        className={classNames('flex gap-half', {
          'absolute right-[14px] top-[18px]': !isSoloStyle
        })}
      >
        <ScarcityDisplayIndicator isToggled={!showRawValue} />
        <ScarcityDisplayIndicator isToggled={showRawValue} />
      </div>

      <Button
        theme="clean"
        className="absolute inset-0 -z-0"
        onClick={() => setShowRawValue(!showRawValue)}
      >
        <span className="sr-only">Toggle Scarcity Display</span>
      </Button>
    </div>
  )
}

const ScarcityDisplayIndicator = ({ isToggled }) => {
  return (
    <div
      className={classNames('w-[6px] h-[6px] bg-gray-700 rounded-full', {
        'bg-gray-300': isToggled
      })}
    />
  )
}
